<app-slider></app-slider>
<app-marquee-section></app-marquee-section>
<!-- <div class="box-custom-yellow">
    <div class="wrapper padding-all-20">
        <div class="row">
            <div class="col-md-3 col-sm-6 col-xs-6">
                <a href="https://nmpksbank.in/assets/ac-form.pdf" target="_black">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    <span class="padding-left-20">अकाउंट ओपनिंग फॉर्म</span>
                </a>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-6">

                <a href="https://play.google.com/store/apps/details?id=com.vpay.vgipl" target="_black">
                    <i class="fa fa-android" aria-hidden="true"></i>
                    <span class="padding-left-20">Download VPAY</span>
                </a>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-6">
                <i class="fa fa-mobile" aria-hidden="true"></i>
                <span class="padding-left-20">ATM सेवा</span>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-6">
                <a routerLink="/about/branches">
                    <i class="fa fa-university" aria-hidden="true"></i>
                    <span class="padding-left-20">Bank IFSC Code</span>
                </a>
            </div>
        </div>
    </div>
</div> -->

<!-- About -->
<section id="about" class="box-white">
    <div class="wrapper padding-all ">
        <!-- Section Content -->
        <div class="row margin-none">
            <div class="col-md-6 col-sm-12 padding-none padding-right-40">
                <!-- About Header -->
                <div class="section-header">
                    <h2 class="letter-spacing">'नागपूर महानगरपालिका कर्मचारी सहकारी बँक लि., नागपूर' वेबसाइट मध्ये आपले स्वागत आहे.</h2>
                    <h3>``सहकारी चळवळीचे यश हे सहकारी संस्थांच्या संख्यात्मक वाढीपेक्षा, सभासदांच्या नैतिकतेवर अधिक अवलंबून असते``</h3>
                </div>
                <!-- About Header End -->
                <!-- About Content -->
                <p class="justify">
                    नागपूर महानगर पालिका कर्मचारी सहकारी बँक लि., नागपूर २१ जुलै १९३४ रोजी सहकारी संस्था कायदा, १९६० अंतर्गत नोंदणी क्र. ३०३ असलेली नागपूर महानगर पालिका कर्मचारी सहकारी पत संस्था नागपूर अस्तितवात आली, ०१ जून १९९५ ला संस्थेचे रूपांतर बॅकेत रूपांतरीत झाले.
                </p>
                <p class="justify">
                    नागपूर महानगर पालिका कर्मचारी सहकारी बँक लि., कोठी रोड, महाल, नागपूर येथे आहे, बँकेकडे ४ शाखा आणि मुख्यालय आहे. महाल ला मुख्यालय तसेच मुख्य शाखा, नंदनवन, पाचपांवली, सिव्हिल लाईन येथे शाखा आहेत.
                </p>
                <p class="justify">
                    बॅकेचे ४८४१ सदस्य आहेत व सर्व सदस्य हे म.न.पा. सेवेत कर्मचारी म्हणुन कार्यरत आहेत, दि. ३१/०३/२०२१ पर्यंत बँकेचे एकुण भागभांडवल १२४०.८२ लाख आहे. </p>
                <p class="justify">
                    आमचे ध्येय आहे, एक सदढ स्पर्धात्मक आर्थिक व्यवस्थेत संस्थेला विकसीत करणे, सर्व सेवा प्रदान करणे, तंत्रज्ञान आणि मानवी संसाधनाचा लाभ घेणे, सर्व भागीदारांना जबाबदारीने संपुर्ण सेवा प्रदान करणे.
                </p>
                <div class="space"></div>
                <div class="button-group clearfix">
                    <a routerLink="/about" class="btn btn-default letter-spacing">अधिक माहिती </a>
                    <a routerLink="/contact" class="btn btn-dark letter-spacing">संपर्क</a>
                </div>
                <!-- About Content End -->
            </div>
            <div class="col-md-6 col-sm-12 padding-none">
                <!-- Counter List -->
                <div class="grid-list counter-list">
                    <div class="row margin-none">
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/services/deposit">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="245" data-speed="5000" data-refresh-interval="50">
                              <img src="assets/img/p-icon-fixed-deposit.png" class="align-middle" alt="nmpksbank">
                            </span>
                                <p class="line-top text-extrabold">मुदत ठेव </p>
                            </a>
                        </div>
                        <!-- Grid Col End-->
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/services/atm">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="820" data-speed="5000" data-refresh-interval="50">
                              <img src="assets/img/p-icon-debit-card.png" class="align-middle" alt="nmpksbank">
                            </span>
                                <p class="line-top text-extrabold">ATM सुविधा </p>
                            </a>
                        </div>
                        <!-- Grid Col End-->
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/services/loan">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="98" data-speed="5000" data-refresh-interval="50">
                                <img src="assets/img/p-icon-personal-loan.png" class="align-middle" alt="nmpksbank">
                              </span>
                                <p class="line-top text-extrabold">कर्ज</p>
                            </a>

                        </div>
                        <!-- Grid Col End-->
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a href="javascript:void(0)" target="_black">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="32" data-speed="5000" data-refresh-interval="50">
                              <img src="assets/img/p-icon-saving-account.png" class="align-middle" alt="nmpksbank">
                            </span>
                                <p class="line-top text-extrabold">
                                    <a href="https://nmpksbank.in/assets/ac.pdf" target="_black">अकाउंट ओपनिंग</a> /
                                    <a href="https://nmpksbank.in/assets/kyc.pdf" target="_black">KYC</a>
                                </p>
                            </a>
                        </div>
                        <!-- Grid Col End-->
                    </div>
                </div>
                <app-team></app-team>

                <!-- Counter List End -->
            </div>

        </div>
        <!-- Section Content End -->
    </div>
    <!-- Customers -->
    <div class="row margin-none col-half">
        <!-- Clients -->
        <div class="col-md-6 col-sm-12 half box-dark padding-all center">
            <!-- Section Header -->
            <div class="section-header">
                <h2>RECENT</h2>
                <h3>Update</h3>
                <!-- तुम्हाला निरोगी आणि समृद्ध नवीन वर्ष 2021 च्या खूप खूप शुभेच्छा. - - - -->
                <p> <b>खबरदारी:</b> कधीही तुमचा कार्ड नंबर, एक्स्पायरी डेट, सीव्हीव्ही, पिन, ओटीपी, पासवर्ड कोणाशीही शेअर करू नका. बँक असे तपशील कधीच विचारत नाही.</p>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 half box-yellow padding-all center">
            <h4 class="title-big center">बातमी</h4>
            <carousel [noWrap]="noWrapSlides" [showIndicators]="showIndicator">
                <slide class="" *ngFor="let item of dataNews">
                    <div class="wrapper" style="width: 100%;">
                        <div class="bx-wrapper" style="max-width: 100%;">
                            <div class="bx-viewport" style="width: 100%; overflow: hidden; position: relative;">
                                <ul class="bxslider" style="width: auto; position: relative;">
                                    <li style="float: none;">
                                        <div class="item center">
                                            <div class="item-comment">
                                                <b>"{{item.nmpk_newsTitle}}"</b>
                                            </div>
                                            <div class="item-name">
                                                {{item.nmpk_newsDesc.slice(0,50)}}...
                                            </div>
                                            <br>
                                            <button class="btn btn-dark btn-xs" routerLink='about/news'>संपूर्ण बातमी</button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</section>
<app-milestone></app-milestone>
<!-- Services -->
<section id="contact" class="box-grey">
    <div class="wrapper padding-all">
        <!-- Section Header -->
        <div class="section-header">
            <h2 class="letter-spacing">आमच्या सेवा </h2>
            <h5>नागपूर महानगरपालिका कर्मचारी सहकारी बँक ली. ही आपल्या ग्राहकांना १९३५ पासून विविध पूर्व सेवा प्रदान करीत आहे.</h5>
            <a routerLink="/services/deposit" class="btn btn-default v-center letter-spacing">बघा संपूर्ण सेवा </a>
        </div>
        <!-- Section Header End -->

        <!-- Grid List -->
        <div class="grid-list">
            <div class="row margin-none">
                <!-- Grid Col -->
                <div class="grid col-md-3 col-sm-6">
                    <p>
                        <img src="assets/img/icon-neft.png" class="align-middle" alt="nmpksbank">
                    </p>

                    <div class="space-20"></div>
                    <h5 class="text-semibold text-space line-bottom">RTGS, NEFT </h5>
                    <!-- <p class="line-bottom">Etiam consectetur ipsum id sem sollicitudin Suspendisse hendrerit odio nec nibh eleifend tempus</p> -->
                </div>
                <!-- Grid Col End-->

                <!-- Grid Col -->
                <div class="grid col-md-3 col-sm-6">
                    <p>
                        <img src="assets/img/icon-drafts.png" class="align-middle" alt="nmpksbank">
                    </p>
                    <div class="space-20"></div>

                    <h5 class="text-semibold text-space line-bottom">Drafts</h5>
                </div>
                <!-- Grid Col End-->

                <!-- Grid Col -->
                <div class="grid col-md-3 col-sm-6">
                    <p>
                        <img src="assets/img/icon-atm.png" class="align-middle" alt="nmpksbank">

                    </p>
                    <div class="space-20"></div>

                    <h5 class="text-semibold text-space line-bottom">ATM / Debit Card</h5>
                </div>
                <!-- Grid Col End-->

                <!-- Grid Col -->
                <div class="grid col-md-3 col-sm-6">
                    <p>
                        <img src="assets/img/icon-locker.png" class="align-middle" alt="nmpksbank">

                    </p>
                    <div class="space-20"></div>

                    <h5 class="text-semibold text-space line-bottom">Lockers</h5>
                </div>
                <!-- Grid Col End-->
            </div>
        </div>
        <!-- Grid List End -->
    </div>
</section>
<!-- Services End -->